// (function () {
//   if (window.__chottoAddonInited) return;
//   window.__chottoAddonInited = true;

//   var cfg = window.__chottoCartAddon;
//   if (!cfg || typeof cfg.thresholdCents !== 'number') return;

//   var THRESHOLD_CENTS = cfg.thresholdCents;
//   var originalFetch = window.fetch;

//   function getCart() {
//     return originalFetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
//   }

//   function getCartDrawerSectionId() {
//     var cartDrawerEl = document.querySelector('cart-drawer');
//     if (!cartDrawerEl) return null;
//     return cartDrawerEl.getAttribute('id') === 'cart-drawer'
//       ? 'cart-drawer'
//       : (cartDrawerEl.dataset.sectionId || 'cart-drawer');
//   }

//   /* ══ Poori section ki visibility (threshold ke hisaab se) aur har tile ki
//      visibility (cart me hai ya nahi, uske hisaab se) — dono sync karo ══ */
//   function syncAddonUI() {
//     getCart().then(function (cart) {
//       var wrapper = document.querySelector('[data-cart-addon-section]');
//       if (!wrapper) return;

//       var showSection = cart.total_price < THRESHOLD_CENTS;
//       wrapper.style.display = showSection ? '' : 'none';
//       if (!showSection) return;

//       var cartProductIds = cart.items.map(function (i) { return String(i.product_id); });

//       wrapper.querySelectorAll('[data-cart-addon-item]').forEach(function (tile) {
//         var pid = tile.dataset.productId;
//         tile.style.display = cartProductIds.indexOf(pid) !== -1 ? 'none' : '';
//       });
//     });
//   }

//   function updateCartCountBubble() {
//     return originalFetch(window.Shopify.routes.root + 'cart.js')
//       .then(function (r) { return r.json(); })
//       .then(function (cart) {
//         document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
//           var span = el.querySelector('span[aria-hidden]');
//           if (span) span.textContent = cart.item_count;
//           el.style.display = cart.item_count > 0 ? '' : 'none';
//         });
//       });
//   }

//   function updateCartDrawerFromSections(sections) {
//     var sectionId = getCartDrawerSectionId();
//     var cartDrawerEl = document.querySelector('cart-drawer');
//     if (!cartDrawerEl || !sectionId || !sections || !sections[sectionId]) return;

//     var parser = new DOMParser();
//     var newDoc = parser.parseFromString(sections[sectionId], 'text/html');
//     var newDrawerInner = newDoc.querySelector('cart-drawer');
//     if (newDrawerInner) cartDrawerEl.innerHTML = newDrawerInner.innerHTML;

//     cartDrawerEl.classList.remove('is-empty');
//     if (typeof cartDrawerEl.open === 'function') {
//       cartDrawerEl.open();
//     } else {
//       cartDrawerEl.classList.add('active');
//       document.body.classList.add('overflow-hidden');
//     }
//   }

//   function refreshDrawerFromServer() {
//     var sectionId = getCartDrawerSectionId();
//     if (!sectionId) return Promise.resolve();
//     return originalFetch(window.Shopify.routes.root + '?sections=' + sectionId)
//       .then(function (r) { return r.json(); })
//       .then(function (data) { updateCartDrawerFromSections(data); });
//   }

//   /* ══ Add-on tile ka "Add" button click — AJAX add, phir drawer + bubble refresh ══ */
// document.addEventListener('click', function (e) {
//   var btn = e.target.closest('[data-cart-addon-add-btn]');
//   if (!btn) return;

//   var form = btn.closest('[data-cart-addon-form]');
//   if (!form) return;

//   e.preventDefault();

//   var idInput = form.querySelector('[name="id"]');
//   var qtyInput = form.querySelector('[name="quantity"]');
//   if (!idInput || !idInput.value) return;

//   btn.disabled = true;

//   var payload = {
//     items: [{
//       id: parseInt(idInput.value, 10),
//       quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
//     }]
//   };

//   var sectionId = getCartDrawerSectionId();
//   if (sectionId) {
//     payload.sections = sectionId;
//     payload.sections_url = window.location.pathname;
//   }

//   originalFetch(window.Shopify.routes.root + 'cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//     body: JSON.stringify(payload)
//   })
//     .then(function (r) {
//       if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
//       return r.json();
//     })
//     .then(function (data) {
//       updateCartDrawerFromSections(data.sections);
//       updateCartCountBubble();
//       setTimeout(syncAddonUI, 150);
//     })
//     .catch(function (err) {
//       console.error('Cart add-on error:', err);
//       btn.disabled = false;
//     });
// });

//   /* ══ Kisi bhi cart-modifying request ke baad (chahe kahi se bhi ho — PDP,
//      Quick View, gift script, addon khud, cart page ke +/- buttons) sync karo ══ */
//   window.fetch = function (input, init) {
//     var url = typeof input === 'string' ? input : (input && input.url) || '';
//     var isCartEndpoint = /\/cart\/(add|change|update)\.js/.test(url);
//     return originalFetch.apply(this, arguments).then(function (response) {
//       if (isCartEndpoint && response.ok) {
//         setTimeout(syncAddonUI, 450);
//       }
//       return response;
//     });
//   };

//   /* ══ MutationObserver — backup safety net ══ */
//   function observeCartAreas() {
//     ['cart-drawer', '#main-cart-items'].forEach(function (sel) {
//       var el = document.querySelector(sel);
//       if (!el || el.dataset.chottoAddonObserved === '1') return;
//       el.dataset.chottoAddonObserved = '1';

//       var debounceTimer = null;
//       var observer = new MutationObserver(function () {
//         clearTimeout(debounceTimer);
//         debounceTimer = setTimeout(syncAddonUI, 450);
//       });
//       observer.observe(el, { childList: true, subtree: true });
//     });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     observeCartAreas();
//     syncAddonUI();
//   });
// })();


(function () {
  if (window.__chottoAddonInited) return;
  window.__chottoAddonInited = true;

  var cfg = window.__chottoCartAddon;
  if (!cfg || typeof cfg.thresholdCents !== 'number') return;

  var THRESHOLD_CENTS = cfg.thresholdCents;
  var ADDON_PRODUCT_IDS = (cfg.addonProductIds || []).map(String);
  var originalFetch = window.fetch;
  var isSyncingAddon = false;

  function isAddonProductId(pid) {
    return ADDON_PRODUCT_IDS.indexOf(String(pid)) !== -1;
  }

  function getCart() {
    return originalFetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
  }

  function getCartDrawerSectionId() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return null;
    return cartDrawerEl.getAttribute('id') === 'cart-drawer'
      ? 'cart-drawer'
      : (cartDrawerEl.dataset.sectionId || 'cart-drawer');
  }

  function updateCartCountBubble() {
    return originalFetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          var span = el.querySelector('span[aria-hidden]');
          if (span) span.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  /* ══ FIX: ab "is-empty" class ko blindly force nahi karte — actual
     item_count dekh kar decide karte hain. Isse jab cart genuinely
     khali ho jaye (orphan-removal ke baad), Dawn ka apna "Your cart is
     empty" empty-state theek se dikhta hai, blank drawer nahi dikhta. ══ */
  function updateCartDrawerFromSections(sections, itemCount) {
    var sectionId = getCartDrawerSectionId();
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl || !sectionId || !sections || !sections[sectionId]) return;

    var parser = new DOMParser();
    var newDoc = parser.parseFromString(sections[sectionId], 'text/html');
    var newDrawerInner = newDoc.querySelector('cart-drawer');
    if (newDrawerInner) cartDrawerEl.innerHTML = newDrawerInner.innerHTML;

    var isActuallyEmpty = itemCount === 0;

    if (isActuallyEmpty) {
      cartDrawerEl.classList.add('is-empty');
    } else {
      cartDrawerEl.classList.remove('is-empty');
    }

    if (typeof cartDrawerEl.open === 'function') {
      cartDrawerEl.open();
    } else {
      cartDrawerEl.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  /* ══ FIX: ab drawer refresh karte waqt asli item_count bhi saath me fetch
     karte hain, taaki empty-state sahi dikhaya ja sake ══ */
  function refreshDrawerFromServer() {
    var sectionId = getCartDrawerSectionId();
    if (!sectionId) return Promise.resolve();
    return Promise.all([
      originalFetch(window.Shopify.routes.root + '?sections=' + sectionId).then(function (r) { return r.json(); }),
      getCart()
    ]).then(function (results) {
      var sectionsData = results[0];
      var cart = results[1];
      updateCartDrawerFromSections(sectionsData, cart.item_count);
    });
  }

  /* ══ Ek ya zyada add-on line items ko sequentially remove karo ══ */
  function removeAddonItems(items) {
    var chain = Promise.resolve();
    items.forEach(function (item) {
      chain = chain.then(function () {
        return originalFetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
    });
    return chain
      .then(function () { return refreshDrawerFromServer(); })
      .then(function () { return updateCartCountBubble(); });
  }

  /* ══ MAIN SYNC — 3 kaam karta hai:
     1) Section ki visibility — sirf tab dikhe jab cart total threshold se kam ho
     2) ORPHAN RULE: agar cart me sirf add-on product bacha hai (koi real
        product nahi), to add-on khud hat jayega — suggestions me wapas aayega.
     3) REDUNDANT RULE: agar cart total threshold cross kar chuka hai (matlab
        free gift already mil raha hai), to paid add-on redundant hai —
        khud hat jayega. ══ */
  function syncAddonUI() {
    if (isSyncingAddon) return;
    isSyncingAddon = true;

    getCart().then(function (cart) {
      var wrapper = document.querySelector('[data-cart-addon-section]');

      var addonItemsInCart = cart.items.filter(function (i) { return isAddonProductId(i.product_id); });
      var nonAddonItems = cart.items.filter(function (i) { return !isAddonProductId(i.product_id); });

      var qualifiesForFreeGift = cart.total_price >= THRESHOLD_CENTS;
      var isOrphaned = nonAddonItems.length === 0;

      if (addonItemsInCart.length > 0 && (isOrphaned || qualifiesForFreeGift)) {
        removeAddonItems(addonItemsInCart).then(function () {
          isSyncingAddon = false;
          syncAddonUI();
        });
        return;
      }

      if (!wrapper) {
        isSyncingAddon = false;
        return;
      }

      var showSection = !qualifiesForFreeGift;
      wrapper.style.display = showSection ? '' : 'none';

      if (showSection) {
        var cartProductIds = cart.items.map(function (i) { return String(i.product_id); });
        wrapper.querySelectorAll('[data-cart-addon-item]').forEach(function (tile) {
          var pid = tile.dataset.productId;
          tile.style.display = cartProductIds.indexOf(pid) !== -1 ? 'none' : '';
        });
      }

      isSyncingAddon = false;
    }).catch(function () { isSyncingAddon = false; });
  }

  /* ══ Add-on tile ka "Add" button click — AJAX add, phir drawer + bubble refresh ══ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-addon-add-btn]');
    if (!btn) return;

    var form = btn.closest('[data-cart-addon-form]');
    if (!form) return;

    e.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;

    btn.disabled = true;

    var payload = {
      items: [{
        id: parseInt(idInput.value, 10),
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      }]
    };

    var sectionId = getCartDrawerSectionId();
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }

    originalFetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function (data) {
        /* Add hone ke baad cart kabhi khali nahi hoti, isliye itemCount ko 1
           (ya kisi bhi non-zero value) treat karna safe hai */
        updateCartDrawerFromSections(data.sections, data.item_count || 1);
        updateCartCountBubble();
        setTimeout(syncAddonUI, 150);
      })
      .catch(function (err) {
        console.error('Cart add-on error:', err);
        btn.disabled = false;
      });
  });

  /* ══ Kisi bhi cart-modifying request ke baad (chahe kahi se bhi ho — PDP,
     Quick View, gift script, addon khud, cart page ke +/- buttons) sync karo ══ */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartEndpoint = /\/cart\/(add|change|update)\.js/.test(url);
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartEndpoint && response.ok) {
        setTimeout(syncAddonUI, 450);
      }
      return response;
    });
  };

  /* ══ MutationObserver — backup safety net ══ */
  function observeCartAreas() {
    ['cart-drawer', '#main-cart-items'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.dataset.chottoAddonObserved === '1') return;
      el.dataset.chottoAddonObserved = '1';

      var debounceTimer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(syncAddonUI, 450);
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeCartAreas();
    syncAddonUI();
  });
})();